import { forwardRef } from 'react';
import cn from 'bem-cn';

import { useMarkdownContent } from './Markdown.hooks';
import { MarkdownProps } from './Markdown.types';
import './Markdown.scss';

const b = cn('markdown');

export const Markdown = forwardRef<HTMLDivElement, MarkdownProps>((props, ref) => {
    const { children, className } = props;

    const content = useMarkdownContent(children);

    return <div ref={ref} className={b.mix(className)} dangerouslySetInnerHTML={{ __html: content }} />;
});
